// Generated from Shopify device_model metaobjects. Do not edit by hand.
(function () {
  var byHandle = {
  "iphone-17-pro-max": {
    "id": "gid://shopify/Metaobject/561755619516",
    "handle": "iphone-17-pro-max",
    "label": "iPhone 17 Pro Max",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-17-pro": {
    "id": "gid://shopify/Metaobject/561755652284",
    "handle": "iphone-17-pro",
    "label": "iPhone 17 Pro",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-air": {
    "id": "gid://shopify/Metaobject/561755685052",
    "handle": "iphone-air",
    "label": "iPhone Air",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-17": {
    "id": "gid://shopify/Metaobject/561755717820",
    "handle": "iphone-17",
    "label": "iPhone 17",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-16-pro-max": {
    "id": "gid://shopify/Metaobject/561755750588",
    "handle": "iphone-16-pro-max",
    "label": "iPhone 16 Pro Max",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-16-pro": {
    "id": "gid://shopify/Metaobject/561755783356",
    "handle": "iphone-16-pro",
    "label": "iPhone 16 Pro",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-16-plus": {
    "id": "gid://shopify/Metaobject/561755816124",
    "handle": "iphone-16-plus",
    "label": "iPhone 16 Plus",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-16": {
    "id": "gid://shopify/Metaobject/561755848892",
    "handle": "iphone-16",
    "label": "iPhone 16",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-17e-16e": {
    "id": "gid://shopify/Metaobject/561755881660",
    "handle": "iphone-17e-16e",
    "label": "iPhone 17e / 16e",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-15-pro-max": {
    "id": "gid://shopify/Metaobject/561755914428",
    "handle": "iphone-15-pro-max",
    "label": "iPhone 15 Pro Max",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-15-pro": {
    "id": "gid://shopify/Metaobject/561755947196",
    "handle": "iphone-15-pro",
    "label": "iPhone 15 Pro",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-15-plus": {
    "id": "gid://shopify/Metaobject/561755979964",
    "handle": "iphone-15-plus",
    "label": "iPhone 15 Plus",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-15": {
    "id": "gid://shopify/Metaobject/561756012732",
    "handle": "iphone-15",
    "label": "iPhone 15",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-14-pro-max": {
    "id": "gid://shopify/Metaobject/561756045500",
    "handle": "iphone-14-pro-max",
    "label": "iPhone 14 Pro Max",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-14-pro": {
    "id": "gid://shopify/Metaobject/561756078268",
    "handle": "iphone-14-pro",
    "label": "iPhone 14 Pro",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-14-plus": {
    "id": "gid://shopify/Metaobject/561756111036",
    "handle": "iphone-14-plus",
    "label": "iPhone 14 Plus",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-14": {
    "id": "gid://shopify/Metaobject/561756143804",
    "handle": "iphone-14",
    "label": "iPhone 14",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-13-pro-max": {
    "id": "gid://shopify/Metaobject/561756176572",
    "handle": "iphone-13-pro-max",
    "label": "iPhone 13 Pro Max",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-13-pro": {
    "id": "gid://shopify/Metaobject/561756209340",
    "handle": "iphone-13-pro",
    "label": "iPhone 13 Pro",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-13-mini": {
    "id": "gid://shopify/Metaobject/561756242108",
    "handle": "iphone-13-mini",
    "label": "iPhone 13 Mini",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-13": {
    "id": "gid://shopify/Metaobject/561756274876",
    "handle": "iphone-13",
    "label": "iPhone 13",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-12-pro-max": {
    "id": "gid://shopify/Metaobject/561756307644",
    "handle": "iphone-12-pro-max",
    "label": "iPhone 12 Pro Max",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-12-pro": {
    "id": "gid://shopify/Metaobject/561756340412",
    "handle": "iphone-12-pro",
    "label": "iPhone 12 Pro",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-12": {
    "id": "gid://shopify/Metaobject/561756373180",
    "handle": "iphone-12",
    "label": "iPhone 12",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-12-mini": {
    "id": "gid://shopify/Metaobject/561756405948",
    "handle": "iphone-12-mini",
    "label": "iPhone 12 Mini",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-11-pro-max": {
    "id": "gid://shopify/Metaobject/561756438716",
    "handle": "iphone-11-pro-max",
    "label": "iPhone 11 Pro Max",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-11-pro": {
    "id": "gid://shopify/Metaobject/561756471484",
    "handle": "iphone-11-pro",
    "label": "iPhone 11 Pro",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-11": {
    "id": "gid://shopify/Metaobject/561756504252",
    "handle": "iphone-11",
    "label": "iPhone 11",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "galaxy-s26-ultra": {
    "id": "gid://shopify/Metaobject/561756537020",
    "handle": "galaxy-s26-ultra",
    "label": "Galaxy S26 Ultra",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s26": {
    "id": "gid://shopify/Metaobject/561756569788",
    "handle": "galaxy-s26",
    "label": "Galaxy S26+",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s25-edge": {
    "id": "gid://shopify/Metaobject/561756602556",
    "handle": "galaxy-s25-edge",
    "label": "Galaxy S25 Edge",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s25-ultra": {
    "id": "gid://shopify/Metaobject/561756635324",
    "handle": "galaxy-s25-ultra",
    "label": "Galaxy S25 Ultra",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s25": {
    "id": "gid://shopify/Metaobject/561756668092",
    "handle": "galaxy-s25",
    "label": "Galaxy S25+",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s24-ultra": {
    "id": "gid://shopify/Metaobject/561756700860",
    "handle": "galaxy-s24-ultra",
    "label": "Galaxy S24 Ultra",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s24": {
    "id": "gid://shopify/Metaobject/561756733628",
    "handle": "galaxy-s24",
    "label": "Galaxy S24+",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-a54": {
    "id": "gid://shopify/Metaobject/561756766396",
    "handle": "galaxy-a54",
    "label": "Galaxy A54",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-a34": {
    "id": "gid://shopify/Metaobject/561756799164",
    "handle": "galaxy-a34",
    "label": "Galaxy A34",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-a53": {
    "id": "gid://shopify/Metaobject/561756831932",
    "handle": "galaxy-a53",
    "label": "Galaxy A53",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-a33": {
    "id": "gid://shopify/Metaobject/561756864700",
    "handle": "galaxy-a33",
    "label": "Galaxy A33",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-a52": {
    "id": "gid://shopify/Metaobject/561756897468",
    "handle": "galaxy-a52",
    "label": "Galaxy A52",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s23-ultra": {
    "id": "gid://shopify/Metaobject/561756930236",
    "handle": "galaxy-s23-ultra",
    "label": "Galaxy S23 Ultra",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s23": {
    "id": "gid://shopify/Metaobject/561756963004",
    "handle": "galaxy-s23",
    "label": "Galaxy S23+",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s22-ultra": {
    "id": "gid://shopify/Metaobject/561756995772",
    "handle": "galaxy-s22-ultra",
    "label": "Galaxy S22 Ultra",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s22": {
    "id": "gid://shopify/Metaobject/561757028540",
    "handle": "galaxy-s22",
    "label": "Galaxy S22+",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s21-ultra": {
    "id": "gid://shopify/Metaobject/561757061308",
    "handle": "galaxy-s21-ultra",
    "label": "Galaxy S21 Ultra",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s21": {
    "id": "gid://shopify/Metaobject/561757094076",
    "handle": "galaxy-s21",
    "label": "Galaxy S21",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "pura-x": {
    "id": "gid://shopify/Metaobject/561757126844",
    "handle": "pura-x",
    "label": "Pura X",
    "brand": "Huawei",
    "family": "",
    "sort": ""
  },
  "galaxy-s23-fe": {
    "id": "gid://shopify/Metaobject/561757159612",
    "handle": "galaxy-s23-fe",
    "label": "Galaxy S23 FE",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "ipad-mini-6-2021": {
    "id": "gid://shopify/Metaobject/561757192380",
    "handle": "ipad-mini-6-2021",
    "label": "iPad Mini 6 2021",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad-mini-7-2024": {
    "id": "gid://shopify/Metaobject/561757225148",
    "handle": "ipad-mini-7-2024",
    "label": "iPad Mini 7 2024",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad-10-2-7-8-9": {
    "id": "gid://shopify/Metaobject/561757257916",
    "handle": "ipad-10-2-7-8-9",
    "label": "iPad 10.2\" (7/8/9)",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad-air-4-5-10-9-2020-2022": {
    "id": "gid://shopify/Metaobject/561757290684",
    "handle": "ipad-air-4-5-10-9-2020-2022",
    "label": "iPad Air 4/5 10.9\" 2020-2022",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad-10-11-a16-10-9-2022-2025": {
    "id": "gid://shopify/Metaobject/561757323452",
    "handle": "ipad-10-11-a16-10-9-2022-2025",
    "label": "iPad 10 / 11 (A16) (10.9\" 2022-2025)",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad-pro-11-2020-2022-m2": {
    "id": "gid://shopify/Metaobject/561757356220",
    "handle": "ipad-pro-11-2020-2022-m2",
    "label": "iPad Pro 11\" 2020-2022 M2",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad-pro-12-9-2021-2022-m2": {
    "id": "gid://shopify/Metaobject/561757388988",
    "handle": "ipad-pro-12-9-2021-2022-m2",
    "label": "iPad Pro 12.9\" 2021-2022 M2",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad-air-6-7-8-11-2024-2026": {
    "id": "gid://shopify/Metaobject/561757421756",
    "handle": "ipad-air-6-7-8-11-2024-2026",
    "label": "iPad Air 6 / 7 / 8 (11\" 2024-2026)",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad-air-6-7-8-13-2024-2026": {
    "id": "gid://shopify/Metaobject/561757454524",
    "handle": "ipad-air-6-7-8-13-2024-2026",
    "label": "iPad Air 6 / 7 / 8 (13\" 2024-2026)",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad-pro-11-2024-2025-m4-m5": {
    "id": "gid://shopify/Metaobject/561757487292",
    "handle": "ipad-pro-11-2024-2025-m4-m5",
    "label": "iPad Pro 11\" (2024-2025 M4-M5)",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad-pro-13-2024-2025-m4-m5": {
    "id": "gid://shopify/Metaobject/561757520060",
    "handle": "ipad-pro-13-2024-2025-m4-m5",
    "label": "iPad Pro 13\" (2024-2025 M4-M5)",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "airpods-pro-3": {
    "id": "gid://shopify/Metaobject/561757552828",
    "handle": "airpods-pro-3",
    "label": "AirPods Pro 3",
    "brand": "Apple",
    "family": "AirPods",
    "sort": ""
  },
  "airpods-pro-2": {
    "id": "gid://shopify/Metaobject/561757585596",
    "handle": "airpods-pro-2",
    "label": "AirPods Pro 2",
    "brand": "Apple",
    "family": "AirPods",
    "sort": ""
  },
  "airpods-3": {
    "id": "gid://shopify/Metaobject/561757618364",
    "handle": "airpods-3",
    "label": "AirPods 3",
    "brand": "Apple",
    "family": "AirPods",
    "sort": ""
  },
  "airpods-pro": {
    "id": "gid://shopify/Metaobject/561757651132",
    "handle": "airpods-pro",
    "label": "AirPods Pro",
    "brand": "Apple",
    "family": "AirPods",
    "sort": ""
  },
  "airpods": {
    "id": "gid://shopify/Metaobject/561757683900",
    "handle": "airpods",
    "label": "AirPods",
    "brand": "Apple",
    "family": "AirPods",
    "sort": ""
  }
};
  var byName = {
  "iphone 17 pro max": {
    "id": "gid://shopify/Metaobject/561755619516",
    "handle": "iphone-17-pro-max",
    "label": "iPhone 17 Pro Max",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-17-pro-max": {
    "id": "gid://shopify/Metaobject/561755619516",
    "handle": "iphone-17-pro-max",
    "label": "iPhone 17 Pro Max",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 17 pro": {
    "id": "gid://shopify/Metaobject/561755652284",
    "handle": "iphone-17-pro",
    "label": "iPhone 17 Pro",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-17-pro": {
    "id": "gid://shopify/Metaobject/561755652284",
    "handle": "iphone-17-pro",
    "label": "iPhone 17 Pro",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone air": {
    "id": "gid://shopify/Metaobject/561755685052",
    "handle": "iphone-air",
    "label": "iPhone Air",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-air": {
    "id": "gid://shopify/Metaobject/561755685052",
    "handle": "iphone-air",
    "label": "iPhone Air",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 17": {
    "id": "gid://shopify/Metaobject/561755717820",
    "handle": "iphone-17",
    "label": "iPhone 17",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-17": {
    "id": "gid://shopify/Metaobject/561755717820",
    "handle": "iphone-17",
    "label": "iPhone 17",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 16 pro max": {
    "id": "gid://shopify/Metaobject/561755750588",
    "handle": "iphone-16-pro-max",
    "label": "iPhone 16 Pro Max",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-16-pro-max": {
    "id": "gid://shopify/Metaobject/561755750588",
    "handle": "iphone-16-pro-max",
    "label": "iPhone 16 Pro Max",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 16 pro": {
    "id": "gid://shopify/Metaobject/561755783356",
    "handle": "iphone-16-pro",
    "label": "iPhone 16 Pro",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-16-pro": {
    "id": "gid://shopify/Metaobject/561755783356",
    "handle": "iphone-16-pro",
    "label": "iPhone 16 Pro",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 16 plus": {
    "id": "gid://shopify/Metaobject/561755816124",
    "handle": "iphone-16-plus",
    "label": "iPhone 16 Plus",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-16-plus": {
    "id": "gid://shopify/Metaobject/561755816124",
    "handle": "iphone-16-plus",
    "label": "iPhone 16 Plus",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 16": {
    "id": "gid://shopify/Metaobject/561755848892",
    "handle": "iphone-16",
    "label": "iPhone 16",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-16": {
    "id": "gid://shopify/Metaobject/561755848892",
    "handle": "iphone-16",
    "label": "iPhone 16",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 17e / 16e": {
    "id": "gid://shopify/Metaobject/561755881660",
    "handle": "iphone-17e-16e",
    "label": "iPhone 17e / 16e",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-17e-16e": {
    "id": "gid://shopify/Metaobject/561755881660",
    "handle": "iphone-17e-16e",
    "label": "iPhone 17e / 16e",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 15 pro max": {
    "id": "gid://shopify/Metaobject/561755914428",
    "handle": "iphone-15-pro-max",
    "label": "iPhone 15 Pro Max",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-15-pro-max": {
    "id": "gid://shopify/Metaobject/561755914428",
    "handle": "iphone-15-pro-max",
    "label": "iPhone 15 Pro Max",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 15 pro": {
    "id": "gid://shopify/Metaobject/561755947196",
    "handle": "iphone-15-pro",
    "label": "iPhone 15 Pro",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-15-pro": {
    "id": "gid://shopify/Metaobject/561755947196",
    "handle": "iphone-15-pro",
    "label": "iPhone 15 Pro",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 15 plus": {
    "id": "gid://shopify/Metaobject/561755979964",
    "handle": "iphone-15-plus",
    "label": "iPhone 15 Plus",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-15-plus": {
    "id": "gid://shopify/Metaobject/561755979964",
    "handle": "iphone-15-plus",
    "label": "iPhone 15 Plus",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 15": {
    "id": "gid://shopify/Metaobject/561756012732",
    "handle": "iphone-15",
    "label": "iPhone 15",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-15": {
    "id": "gid://shopify/Metaobject/561756012732",
    "handle": "iphone-15",
    "label": "iPhone 15",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 14 pro max": {
    "id": "gid://shopify/Metaobject/561756045500",
    "handle": "iphone-14-pro-max",
    "label": "iPhone 14 Pro Max",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-14-pro-max": {
    "id": "gid://shopify/Metaobject/561756045500",
    "handle": "iphone-14-pro-max",
    "label": "iPhone 14 Pro Max",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 14 pro": {
    "id": "gid://shopify/Metaobject/561756078268",
    "handle": "iphone-14-pro",
    "label": "iPhone 14 Pro",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-14-pro": {
    "id": "gid://shopify/Metaobject/561756078268",
    "handle": "iphone-14-pro",
    "label": "iPhone 14 Pro",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 14 plus": {
    "id": "gid://shopify/Metaobject/561756111036",
    "handle": "iphone-14-plus",
    "label": "iPhone 14 Plus",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-14-plus": {
    "id": "gid://shopify/Metaobject/561756111036",
    "handle": "iphone-14-plus",
    "label": "iPhone 14 Plus",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 14": {
    "id": "gid://shopify/Metaobject/561756143804",
    "handle": "iphone-14",
    "label": "iPhone 14",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-14": {
    "id": "gid://shopify/Metaobject/561756143804",
    "handle": "iphone-14",
    "label": "iPhone 14",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 13 pro max": {
    "id": "gid://shopify/Metaobject/561756176572",
    "handle": "iphone-13-pro-max",
    "label": "iPhone 13 Pro Max",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-13-pro-max": {
    "id": "gid://shopify/Metaobject/561756176572",
    "handle": "iphone-13-pro-max",
    "label": "iPhone 13 Pro Max",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 13 pro": {
    "id": "gid://shopify/Metaobject/561756209340",
    "handle": "iphone-13-pro",
    "label": "iPhone 13 Pro",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-13-pro": {
    "id": "gid://shopify/Metaobject/561756209340",
    "handle": "iphone-13-pro",
    "label": "iPhone 13 Pro",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 13 mini": {
    "id": "gid://shopify/Metaobject/561756242108",
    "handle": "iphone-13-mini",
    "label": "iPhone 13 Mini",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-13-mini": {
    "id": "gid://shopify/Metaobject/561756242108",
    "handle": "iphone-13-mini",
    "label": "iPhone 13 Mini",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 13": {
    "id": "gid://shopify/Metaobject/561756274876",
    "handle": "iphone-13",
    "label": "iPhone 13",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-13": {
    "id": "gid://shopify/Metaobject/561756274876",
    "handle": "iphone-13",
    "label": "iPhone 13",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 12 pro max": {
    "id": "gid://shopify/Metaobject/561756307644",
    "handle": "iphone-12-pro-max",
    "label": "iPhone 12 Pro Max",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-12-pro-max": {
    "id": "gid://shopify/Metaobject/561756307644",
    "handle": "iphone-12-pro-max",
    "label": "iPhone 12 Pro Max",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 12 pro": {
    "id": "gid://shopify/Metaobject/561756340412",
    "handle": "iphone-12-pro",
    "label": "iPhone 12 Pro",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-12-pro": {
    "id": "gid://shopify/Metaobject/561756340412",
    "handle": "iphone-12-pro",
    "label": "iPhone 12 Pro",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 12": {
    "id": "gid://shopify/Metaobject/561756373180",
    "handle": "iphone-12",
    "label": "iPhone 12",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-12": {
    "id": "gid://shopify/Metaobject/561756373180",
    "handle": "iphone-12",
    "label": "iPhone 12",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 12 mini": {
    "id": "gid://shopify/Metaobject/561756405948",
    "handle": "iphone-12-mini",
    "label": "iPhone 12 Mini",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-12-mini": {
    "id": "gid://shopify/Metaobject/561756405948",
    "handle": "iphone-12-mini",
    "label": "iPhone 12 Mini",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 11 pro max": {
    "id": "gid://shopify/Metaobject/561756438716",
    "handle": "iphone-11-pro-max",
    "label": "iPhone 11 Pro Max",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-11-pro-max": {
    "id": "gid://shopify/Metaobject/561756438716",
    "handle": "iphone-11-pro-max",
    "label": "iPhone 11 Pro Max",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 11 pro": {
    "id": "gid://shopify/Metaobject/561756471484",
    "handle": "iphone-11-pro",
    "label": "iPhone 11 Pro",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-11-pro": {
    "id": "gid://shopify/Metaobject/561756471484",
    "handle": "iphone-11-pro",
    "label": "iPhone 11 Pro",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone 11": {
    "id": "gid://shopify/Metaobject/561756504252",
    "handle": "iphone-11",
    "label": "iPhone 11",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "iphone-11": {
    "id": "gid://shopify/Metaobject/561756504252",
    "handle": "iphone-11",
    "label": "iPhone 11",
    "brand": "Apple",
    "family": "iPhone",
    "sort": ""
  },
  "galaxy s26 ultra": {
    "id": "gid://shopify/Metaobject/561756537020",
    "handle": "galaxy-s26-ultra",
    "label": "Galaxy S26 Ultra",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s26-ultra": {
    "id": "gid://shopify/Metaobject/561756537020",
    "handle": "galaxy-s26-ultra",
    "label": "Galaxy S26 Ultra",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy s26+": {
    "id": "gid://shopify/Metaobject/561756569788",
    "handle": "galaxy-s26",
    "label": "Galaxy S26+",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s26": {
    "id": "gid://shopify/Metaobject/561756569788",
    "handle": "galaxy-s26",
    "label": "Galaxy S26+",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy s25 edge": {
    "id": "gid://shopify/Metaobject/561756602556",
    "handle": "galaxy-s25-edge",
    "label": "Galaxy S25 Edge",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s25-edge": {
    "id": "gid://shopify/Metaobject/561756602556",
    "handle": "galaxy-s25-edge",
    "label": "Galaxy S25 Edge",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy s25 ultra": {
    "id": "gid://shopify/Metaobject/561756635324",
    "handle": "galaxy-s25-ultra",
    "label": "Galaxy S25 Ultra",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s25-ultra": {
    "id": "gid://shopify/Metaobject/561756635324",
    "handle": "galaxy-s25-ultra",
    "label": "Galaxy S25 Ultra",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy s25+": {
    "id": "gid://shopify/Metaobject/561756668092",
    "handle": "galaxy-s25",
    "label": "Galaxy S25+",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s25": {
    "id": "gid://shopify/Metaobject/561756668092",
    "handle": "galaxy-s25",
    "label": "Galaxy S25+",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy s24 ultra": {
    "id": "gid://shopify/Metaobject/561756700860",
    "handle": "galaxy-s24-ultra",
    "label": "Galaxy S24 Ultra",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s24-ultra": {
    "id": "gid://shopify/Metaobject/561756700860",
    "handle": "galaxy-s24-ultra",
    "label": "Galaxy S24 Ultra",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy s24+": {
    "id": "gid://shopify/Metaobject/561756733628",
    "handle": "galaxy-s24",
    "label": "Galaxy S24+",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s24": {
    "id": "gid://shopify/Metaobject/561756733628",
    "handle": "galaxy-s24",
    "label": "Galaxy S24+",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy a54": {
    "id": "gid://shopify/Metaobject/561756766396",
    "handle": "galaxy-a54",
    "label": "Galaxy A54",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-a54": {
    "id": "gid://shopify/Metaobject/561756766396",
    "handle": "galaxy-a54",
    "label": "Galaxy A54",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy a34": {
    "id": "gid://shopify/Metaobject/561756799164",
    "handle": "galaxy-a34",
    "label": "Galaxy A34",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-a34": {
    "id": "gid://shopify/Metaobject/561756799164",
    "handle": "galaxy-a34",
    "label": "Galaxy A34",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy a53": {
    "id": "gid://shopify/Metaobject/561756831932",
    "handle": "galaxy-a53",
    "label": "Galaxy A53",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-a53": {
    "id": "gid://shopify/Metaobject/561756831932",
    "handle": "galaxy-a53",
    "label": "Galaxy A53",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy a33": {
    "id": "gid://shopify/Metaobject/561756864700",
    "handle": "galaxy-a33",
    "label": "Galaxy A33",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-a33": {
    "id": "gid://shopify/Metaobject/561756864700",
    "handle": "galaxy-a33",
    "label": "Galaxy A33",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy a52": {
    "id": "gid://shopify/Metaobject/561756897468",
    "handle": "galaxy-a52",
    "label": "Galaxy A52",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-a52": {
    "id": "gid://shopify/Metaobject/561756897468",
    "handle": "galaxy-a52",
    "label": "Galaxy A52",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy s23 ultra": {
    "id": "gid://shopify/Metaobject/561756930236",
    "handle": "galaxy-s23-ultra",
    "label": "Galaxy S23 Ultra",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s23-ultra": {
    "id": "gid://shopify/Metaobject/561756930236",
    "handle": "galaxy-s23-ultra",
    "label": "Galaxy S23 Ultra",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy s23+": {
    "id": "gid://shopify/Metaobject/561756963004",
    "handle": "galaxy-s23",
    "label": "Galaxy S23+",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s23": {
    "id": "gid://shopify/Metaobject/561756963004",
    "handle": "galaxy-s23",
    "label": "Galaxy S23+",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy s22 ultra": {
    "id": "gid://shopify/Metaobject/561756995772",
    "handle": "galaxy-s22-ultra",
    "label": "Galaxy S22 Ultra",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s22-ultra": {
    "id": "gid://shopify/Metaobject/561756995772",
    "handle": "galaxy-s22-ultra",
    "label": "Galaxy S22 Ultra",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy s22+": {
    "id": "gid://shopify/Metaobject/561757028540",
    "handle": "galaxy-s22",
    "label": "Galaxy S22+",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s22": {
    "id": "gid://shopify/Metaobject/561757028540",
    "handle": "galaxy-s22",
    "label": "Galaxy S22+",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy s21 ultra": {
    "id": "gid://shopify/Metaobject/561757061308",
    "handle": "galaxy-s21-ultra",
    "label": "Galaxy S21 Ultra",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s21-ultra": {
    "id": "gid://shopify/Metaobject/561757061308",
    "handle": "galaxy-s21-ultra",
    "label": "Galaxy S21 Ultra",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy s21": {
    "id": "gid://shopify/Metaobject/561757094076",
    "handle": "galaxy-s21",
    "label": "Galaxy S21",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s21": {
    "id": "gid://shopify/Metaobject/561757094076",
    "handle": "galaxy-s21",
    "label": "Galaxy S21",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "pura x": {
    "id": "gid://shopify/Metaobject/561757126844",
    "handle": "pura-x",
    "label": "Pura X",
    "brand": "Huawei",
    "family": "",
    "sort": ""
  },
  "pura-x": {
    "id": "gid://shopify/Metaobject/561757126844",
    "handle": "pura-x",
    "label": "Pura X",
    "brand": "Huawei",
    "family": "",
    "sort": ""
  },
  "galaxy s23 fe": {
    "id": "gid://shopify/Metaobject/561757159612",
    "handle": "galaxy-s23-fe",
    "label": "Galaxy S23 FE",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "galaxy-s23-fe": {
    "id": "gid://shopify/Metaobject/561757159612",
    "handle": "galaxy-s23-fe",
    "label": "Galaxy S23 FE",
    "brand": "Samsung",
    "family": "Galaxy",
    "sort": ""
  },
  "ipad mini 6 2021": {
    "id": "gid://shopify/Metaobject/561757192380",
    "handle": "ipad-mini-6-2021",
    "label": "iPad Mini 6 2021",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad-mini-6-2021": {
    "id": "gid://shopify/Metaobject/561757192380",
    "handle": "ipad-mini-6-2021",
    "label": "iPad Mini 6 2021",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad mini 7 2024": {
    "id": "gid://shopify/Metaobject/561757225148",
    "handle": "ipad-mini-7-2024",
    "label": "iPad Mini 7 2024",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad-mini-7-2024": {
    "id": "gid://shopify/Metaobject/561757225148",
    "handle": "ipad-mini-7-2024",
    "label": "iPad Mini 7 2024",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad 10.2\" (7/8/9)": {
    "id": "gid://shopify/Metaobject/561757257916",
    "handle": "ipad-10-2-7-8-9",
    "label": "iPad 10.2\" (7/8/9)",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad-10-2-7-8-9": {
    "id": "gid://shopify/Metaobject/561757257916",
    "handle": "ipad-10-2-7-8-9",
    "label": "iPad 10.2\" (7/8/9)",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad air 4/5 10.9\" 2020-2022": {
    "id": "gid://shopify/Metaobject/561757290684",
    "handle": "ipad-air-4-5-10-9-2020-2022",
    "label": "iPad Air 4/5 10.9\" 2020-2022",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad-air-4-5-10-9-2020-2022": {
    "id": "gid://shopify/Metaobject/561757290684",
    "handle": "ipad-air-4-5-10-9-2020-2022",
    "label": "iPad Air 4/5 10.9\" 2020-2022",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad 10 / 11 (a16) (10.9\" 2022-2025)": {
    "id": "gid://shopify/Metaobject/561757323452",
    "handle": "ipad-10-11-a16-10-9-2022-2025",
    "label": "iPad 10 / 11 (A16) (10.9\" 2022-2025)",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad-10-11-a16-10-9-2022-2025": {
    "id": "gid://shopify/Metaobject/561757323452",
    "handle": "ipad-10-11-a16-10-9-2022-2025",
    "label": "iPad 10 / 11 (A16) (10.9\" 2022-2025)",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad pro 11\" 2020-2022 m2": {
    "id": "gid://shopify/Metaobject/561757356220",
    "handle": "ipad-pro-11-2020-2022-m2",
    "label": "iPad Pro 11\" 2020-2022 M2",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad-pro-11-2020-2022-m2": {
    "id": "gid://shopify/Metaobject/561757356220",
    "handle": "ipad-pro-11-2020-2022-m2",
    "label": "iPad Pro 11\" 2020-2022 M2",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad pro 12.9\" 2021-2022 m2": {
    "id": "gid://shopify/Metaobject/561757388988",
    "handle": "ipad-pro-12-9-2021-2022-m2",
    "label": "iPad Pro 12.9\" 2021-2022 M2",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad-pro-12-9-2021-2022-m2": {
    "id": "gid://shopify/Metaobject/561757388988",
    "handle": "ipad-pro-12-9-2021-2022-m2",
    "label": "iPad Pro 12.9\" 2021-2022 M2",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad air 6 / 7 / 8 (11\" 2024-2026)": {
    "id": "gid://shopify/Metaobject/561757421756",
    "handle": "ipad-air-6-7-8-11-2024-2026",
    "label": "iPad Air 6 / 7 / 8 (11\" 2024-2026)",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad-air-6-7-8-11-2024-2026": {
    "id": "gid://shopify/Metaobject/561757421756",
    "handle": "ipad-air-6-7-8-11-2024-2026",
    "label": "iPad Air 6 / 7 / 8 (11\" 2024-2026)",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad air 6 / 7 / 8 (13\" 2024-2026)": {
    "id": "gid://shopify/Metaobject/561757454524",
    "handle": "ipad-air-6-7-8-13-2024-2026",
    "label": "iPad Air 6 / 7 / 8 (13\" 2024-2026)",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad-air-6-7-8-13-2024-2026": {
    "id": "gid://shopify/Metaobject/561757454524",
    "handle": "ipad-air-6-7-8-13-2024-2026",
    "label": "iPad Air 6 / 7 / 8 (13\" 2024-2026)",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad pro 11\" (2024-2025 m4-m5)": {
    "id": "gid://shopify/Metaobject/561757487292",
    "handle": "ipad-pro-11-2024-2025-m4-m5",
    "label": "iPad Pro 11\" (2024-2025 M4-M5)",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad-pro-11-2024-2025-m4-m5": {
    "id": "gid://shopify/Metaobject/561757487292",
    "handle": "ipad-pro-11-2024-2025-m4-m5",
    "label": "iPad Pro 11\" (2024-2025 M4-M5)",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad pro 13\" (2024-2025 m4-m5)": {
    "id": "gid://shopify/Metaobject/561757520060",
    "handle": "ipad-pro-13-2024-2025-m4-m5",
    "label": "iPad Pro 13\" (2024-2025 M4-M5)",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "ipad-pro-13-2024-2025-m4-m5": {
    "id": "gid://shopify/Metaobject/561757520060",
    "handle": "ipad-pro-13-2024-2025-m4-m5",
    "label": "iPad Pro 13\" (2024-2025 M4-M5)",
    "brand": "Apple",
    "family": "iPad",
    "sort": ""
  },
  "airpods pro 3": {
    "id": "gid://shopify/Metaobject/561757552828",
    "handle": "airpods-pro-3",
    "label": "AirPods Pro 3",
    "brand": "Apple",
    "family": "AirPods",
    "sort": ""
  },
  "airpods-pro-3": {
    "id": "gid://shopify/Metaobject/561757552828",
    "handle": "airpods-pro-3",
    "label": "AirPods Pro 3",
    "brand": "Apple",
    "family": "AirPods",
    "sort": ""
  },
  "airpods pro 2": {
    "id": "gid://shopify/Metaobject/561757585596",
    "handle": "airpods-pro-2",
    "label": "AirPods Pro 2",
    "brand": "Apple",
    "family": "AirPods",
    "sort": ""
  },
  "airpods-pro-2": {
    "id": "gid://shopify/Metaobject/561757585596",
    "handle": "airpods-pro-2",
    "label": "AirPods Pro 2",
    "brand": "Apple",
    "family": "AirPods",
    "sort": ""
  },
  "airpods 3": {
    "id": "gid://shopify/Metaobject/561757618364",
    "handle": "airpods-3",
    "label": "AirPods 3",
    "brand": "Apple",
    "family": "AirPods",
    "sort": ""
  },
  "airpods-3": {
    "id": "gid://shopify/Metaobject/561757618364",
    "handle": "airpods-3",
    "label": "AirPods 3",
    "brand": "Apple",
    "family": "AirPods",
    "sort": ""
  },
  "airpods pro": {
    "id": "gid://shopify/Metaobject/561757651132",
    "handle": "airpods-pro",
    "label": "AirPods Pro",
    "brand": "Apple",
    "family": "AirPods",
    "sort": ""
  },
  "airpods-pro": {
    "id": "gid://shopify/Metaobject/561757651132",
    "handle": "airpods-pro",
    "label": "AirPods Pro",
    "brand": "Apple",
    "family": "AirPods",
    "sort": ""
  },
  "airpods": {
    "id": "gid://shopify/Metaobject/561757683900",
    "handle": "airpods",
    "label": "AirPods",
    "brand": "Apple",
    "family": "AirPods",
    "sort": ""
  }
};

  function normalizeName(value) {
    return String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
  }

  function resolveModel(value) {
    if (!value) return null;
    var raw = String(value || '').trim();
    return byHandle[raw] || byName[normalizeName(raw)] || null;
  }

  function resolveModelElement(item) {
    if (!item) return null;
    return resolveModel(item.getAttribute('data-model-reference'))
      || resolveModel(item.getAttribute('data-model-name'))
      || resolveModel(item.getAttribute('data-model-value'))
      || resolveModel(item.textContent);
  }

  function applyToModelItems(root) {
    var scope = root || document;
    if (!scope.querySelectorAll) return;
    scope.querySelectorAll('[data-collection-model-item], [data-header-model-item], [data-model-drawer-item]').forEach(function (item) {
      var model = resolveModelElement(item);
      if (!model || !model.id) return;
      item.setAttribute('data-model-filter-value', model.id);
      item.setAttribute('data-model-reference', model.handle);
      if (!item.getAttribute('data-model-name')) item.setAttribute('data-model-name', model.label);
    });
  }

  function getCurrentUrlModel() {
    var params = new URLSearchParams(window.location.search || '');
    var modelName = (params.get('model') || '').split(',')[0].trim();
    return resolveModel(modelName);
  }

  function correctUrlModelReference() {
    if (!window.location || !window.location.search) return false;
    var model = getCurrentUrlModel();
    if (!model || !model.id) return false;
    var url = new URL(window.location.href);
    var current = url.searchParams.get('filter.p.m.custom.model_reference') || '';
    if (current === model.id) return false;
    url.searchParams.set('filter.p.m.custom.model_reference', model.id);
    url.searchParams.delete('page');
    window.location.replace(url.pathname + '?' + url.searchParams.toString() + url.hash);
    return true;
  }

  window.thehoodDeviceModelMap = {
    byHandle: byHandle,
    byName: byName,
    normalizeName: normalizeName,
    resolveModel: resolveModel,
    resolveModelElement: resolveModelElement,
    applyToModelItems: applyToModelItems,
    correctUrlModelReference: correctUrlModelReference
  };

  if (!correctUrlModelReference()) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { applyToModelItems(document); });
    } else {
      applyToModelItems(document);
    }
    document.addEventListener('shopify:section:load', function (event) { applyToModelItems(event.target); });
  }
})();
